export default "__VITE_ASSET__EDP$xlVb__"